export interface DmrFuelDataRow {
  id?: number;
  engine: string;
  consumption: string | number;
  runningHours: string | number;
  average: string | number;
  lastRunningHours?: string | number;
  openingRunningHours?: string | number;
  closingRunningHours?: string | number;
}

export interface DmrFuelConsumptionRow {
  id?: number;
  date: string;
  portMEOpening: string;
  portMEClosing: string;
  pmeRun: number;
  stbdMEOpening: string;
  stbdMEClosing: string;
  smeRun: number;
  fuelConsByMEs: string;
  portGenRun: string;
  stbdGenRun: string;
  fuelConsByGens: number;
  robOpeningLtr: string;
  transfer: string;
  received: string;
  consumption: number;
  robClosingLtr: number;
}

export interface DmrMovementReportRow {
  id?: number;
  berShifting: string;
  pilotName: string;
  startedBothME: string;
  cOff: string;
  makeFastPushStart: string;
  lineCastOffPushStop: string;
  pilotRelease: string;
  alongSideFinishedME: string;
  totalRHrs: string;
  otherTug: string;
  remarks: string;
}

export interface DmrLubeOilRow {
  id?: number;
  grades: string;
  openingStock: string;
  received: string;
  consumedByVessel: string;
  closingStock: string;
}

export interface DailyMovementReportRecord {
  id?: number;
  reportDate: string;
  vesselName: string;
  vesselId?: number;
  voyageNo?: string;
  vesselStatus: string;
  isOffHire?: boolean;
  positionLocation: string;
  positionTime: string;
  positionLat: string;
  positionLon: string;

  dfdOpeningStock: string;
  dfdTotalConsumption: string;
  dfdBunker: string;
  dfdClosingStock: string;
  dfdLastRunningHrs?: string;
  dfdTotalRunningHrs?: string;
  dfdMeCons: string;
  dfdHydEngineCons: string;
  dfdDredgeEngineCons: string;
  dfdAeCons: string;
  dfdHarborDgCons: string;
  dfdBtCons: string;
  dfdTotalFoCons: string;
  dfdRemarks: string;

  status: 'DRAFT' | 'SUBMITTED';
  createdByRank?: string;
  createdByUsername?: string;
  createdDateTime?: string;
  updatedDateTime?: string;

  fuelRows: DmrFuelDataRow[];
  lubeRows: DmrLubeOilRow[];
  fuelConsumptionRows: DmrFuelConsumptionRow[];
  movementReportRows: DmrMovementReportRow[];
}

export const blankDailyMovementReport = (): DailyMovementReportRecord => ({
  reportDate: new Date().toISOString().split('T')[0],
  vesselName: '',
  vesselStatus: '',
  isOffHire: false,
  positionLocation: '',
  positionTime: '',
  positionLat: '',
  positionLon: '',

  dfdOpeningStock: '',
  dfdTotalConsumption: '',
  dfdBunker: '',
  dfdClosingStock: '',
  dfdLastRunningHrs: '',
  dfdTotalRunningHrs: '',
  dfdMeCons: '',
  dfdHydEngineCons: '',
  dfdDredgeEngineCons: '',
  dfdAeCons: '',
  dfdHarborDgCons: '',
  dfdBtCons: '',
  dfdTotalFoCons: '',
  dfdRemarks: '',

  status: 'DRAFT',

  fuelRows: [],
  lubeRows: [],
  fuelConsumptionRows: [],
  movementReportRows: []
});

export const blankFuelConsumptionRow = (): DmrFuelConsumptionRow => ({
  date: '',
  portMEOpening: '',
  portMEClosing: '',
  pmeRun: 0,
  stbdMEOpening: '',
  stbdMEClosing: '',
  smeRun: 0,
  fuelConsByMEs: '',
  portGenRun: '',
  stbdGenRun: '',
  fuelConsByGens: 0,
  robOpeningLtr: '',
  transfer: '',
  received: '',
  consumption: 0,
  robClosingLtr: 0,
});

export const blankMovementReportRow = (): DmrMovementReportRow => ({
  berShifting: '',
  pilotName: '',
  startedBothME: '',
  cOff: '',
  makeFastPushStart: '',
  lineCastOffPushStop: '',
  pilotRelease: '',
  alongSideFinishedME: '',
  totalRHrs: '',
  otherTug: '',
  remarks: '',
});
